import React, { useEffect } from 'react'
import { Switch, Route, useLocation, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import { useGlobalState } from '@/state'
import PageTitle from '@/Layout/PageTitle'
import CourseChat from '@/pages/content/CourseChat'
import CourseIndex from '@/pages/content/CourseIndex'
import CourseMaterialShow from '@/pages/content/CourseMaterialShow'
import LessonShow from '@/pages/content/LessonShow'
import LibraryShow from '@/pages/content/LibraryShow'

function breadCrumbs() {
  const location = useLocation()
  const activePath = location.pathname
  const crumbs = [
  ]
  // Courses hang off Enrolling Courses, matching the sidebar's name for that
  // destination and the trail the Rails course pages use.
  if (activePath.includes('/c/')) {
    const [ currentCourse ] = useGlobalState('currentCourse')
    crumbs.push({ to: '/courses', name: 'Enrolling Courses' })
    crumbs.push({ to: activePath, name: currentCourse?.name || 'Course' })
  }
  if (activePath.includes('/course-material/')) {
    const [ currentCourse ] = useGlobalState('currentCourse')
    crumbs.push({ to: '/courses', name: 'Enrolling Courses' })
    crumbs.push({ to: activePath, name: currentCourse?.name || 'Course' })
  }
  return crumbs
}

function pageTitle() {
  const location = useLocation()
  const activePath = location.pathname
  const titleInfo = {
     title: '',
    buttons: [ ]
  }
  if (activePath.includes('/c/')) {
    const [ currentCourse ] = useGlobalState('currentCourse')
    let title = currentCourse?.name || 'Course'
    titleInfo.title = title
  }
  if (activePath.includes('/course-material/')) {
    const [ currentCourse ] = useGlobalState('currentCourse')
    let title = currentCourse?.name || 'Course'
    titleInfo.title = title
  }
  return titleInfo
}

export default function ContentContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()


  return <>
    <Switch>
      <Route {...props} exact path={`/c/:id`}>
        <Breadcrumbs>
          { crumbs.map((crumb, index) => (
            <Link key={crumb.name} to={crumb.to} className="text-sm font-medium text-slate-500 hover:text-clcpurple dark:text-slate-300">
              {crumb.name}
            </Link>
          ))}
        </Breadcrumbs>
        <PageTitle pagetitle={titleInfo.title}>
          {titleInfo.buttons}
        </PageTitle>
        <CourseIndex />
      </Route>
      <Route {...props} exact path={`/c/:id/chat`}>
        <CourseChat />
      </Route>
      <Route {...props} exact path={`/course-material/:courseId`}>
        <Breadcrumbs>
          { crumbs.map((crumb, index) => (
            <Link key={crumb.name} to={crumb.to} className="text-sm font-medium text-slate-500 hover:text-clcpurple dark:text-slate-300">
              {crumb.name}
            </Link>
          ))}
        </Breadcrumbs>
        <PageTitle pagetitle={titleInfo.title}>
          {titleInfo.buttons}
        </PageTitle>
        <CourseMaterialShow />
      </Route>
      <Route {...props} exact path={`/l/:id`}>
        <LessonShow />
      </Route>
      <Route {...props} exact path={`/library/:id`}>
        <LibraryShow />
      </Route>
    </Switch>
  </>
}
